import { createRef, h } from "preact";
import Downshift from "downshift";
import uniqBy from "lodash/uniqBy";

import { classNames, renderHtml, textContains } from "../helpers.js";

import List from "./List.jsx";
import ListItem from "./ListItem.jsx";
import TextField from "./TextField.jsx";
import { useEffect, useState } from "preact/hooks";
import Icon from "./Icon.jsx";

function addHighlight(text, value) {
  const index = text.toLowerCase().indexOf(value.toLowerCase());
  if (index === -1) {
    return text;
  }

  return [
    text.substr(0, index),
    '<span class="auto-suggest__highlight">',
    text.substr(index, value.length),
    "</span>",
    text.substr(index + value.length),
  ]
    .filter((x) => x)
    .join("");
}

export default function AutoSuggest({
  value,
  suggestions,
  onBlur,
  onChange,
  onKeyUp,
  onKeyDown,
  onSelect,
  inputProps,
  showCaret,
}) {
  const ref = createRef();
  const [inputValue, setInputValue] = useState();

  useEffect(() => {
    setInputValue(value);
  }, []);

  function handleChange(item) {
    onChange(item.text);
    ref.current.base && ref.current.base.querySelector("input").blur();
  }

  function handleInput(value) {
    setInputValue(value);
    onChange(value);
  }

  function handleClick() {
    ref.current.openMenu();
  }

  return (
    <Downshift
      onSelect={onSelect}
      onChange={handleChange}
      onInputValueChange={handleInput}
      itemToString={(item) => (item ? item.text : inputValue)}
      inputValue={value}
      ref={ref}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        isOpen,
        inputValue,
        highlightedIndex,
        getRootProps,
      }) => (
        <div
          class="auto-suggest mt-0"
          {...getRootProps({}, { suppressRefError: true })}
        >
          <TextField
            {...inputProps}
            {...getInputProps({ onBlur })}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            onClick={handleClick}
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
          />
          <List
            class={classNames(
              "auto-suggest__list",
              isOpen && "auto-suggest__list--open"
            )}
            {...getMenuProps()}
          >
            {isOpen
              ? uniqBy(
                  suggestions.filter(
                    (item) =>
                      !inputValue || textContains(item?.text, inputValue)
                  ),
                  "text"
                ).map((item, index) => (
                  <ListItem
                    iconFront={
                      item.image && (
                        <span class="passpartout">
                          <img src={item.image} />
                        </span>
                      )
                    }
                    class={classNames(
                      "auto-suggest__list-item",
                      highlightedIndex === index &&
                        "auto-suggest__list-item--active"
                    )}
                    {...getItemProps({
                      key: index,
                      index,
                      item,
                    })}
                  >
                    {renderHtml(addHighlight(item.text, value || ""))}
                  </ListItem>
                ))
              : null}
          </List>
          {showCaret && <Icon class="auto-suggest__icon">expand_more</Icon>}
        </div>
      )}
    </Downshift>
  );
}
